var v2 = module.exports = {
  Generator: require('./generator'),
  Parser: require('./parser')
};
